import { apiV2 } from 'lib/api/v2'
import useSwr from 'swr'

type FirstAndLastOrderDate = {
  firstDate: string
  lastDate: string
}

async function fetcher(): Promise<FirstAndLastOrderDate> {
  const response = await apiV2.get<FirstAndLastOrderDate>(
    'private/order/metrics/order-dates'
  )

  return response.data
}

export function useFirstAndLastOrderDate() {
  return useSwr(['getFirstAndLastOrderDate'], fetcher)
}
